import { render, staticRenderFns } from "./revent.vue?vue&type=template&id=7963ef2f&scoped=true&"
import script from "./revent.vue?vue&type=script&lang=js&"
export * from "./revent.vue?vue&type=script&lang=js&"
import style0 from "./revent.vue?vue&type=style&index=0&id=7963ef2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963ef2f",
  null
  
)

export default component.exports